/* Shto reveal: our sections ([data-shto-section]) that start below the screen fade up the first time they scroll in.
   Sections on screen at load, the sticky bar, and every section with reduced motion are left alone. */
(function () {
  if (window.ShtoReveal) return;
  window.ShtoReveal = true;
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var cfg = document.querySelector('[data-shto-reveal-settings]');
  var root = document.documentElement;
  if (cfg) {
    root.style.setProperty('--shto-reveal-distance', (cfg.dataset.distance || 16) + 'px');
    root.style.setProperty('--shto-reveal-duration', (cfg.dataset.duration || 700) + 'ms');
  }
  var skip = { 'shto-sticky-atc': 1 };
  var fold = window.innerHeight;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-in');
      io.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px' });
  document.querySelectorAll('[data-shto-section]').forEach(function (section) {
    if (skip[section.dataset.shtoSection]) return;
    if (section.getBoundingClientRect().top < fold) return; // already seen: never hide what is on screen
    section.classList.add('shto-reveal');
    io.observe(section);
  });
})();
